export function isNumeric(x: any) {
  if (typeof x === 'number') return isFinite(x)
  if (typeof x === 'string') {
    // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    // and ensure strings of whitespace fail
    return !isNaN(x as unknown as number) && !isNaN(parseFloat(x))
  }
  return false
}
